class AdminModel {
  _data = {
    id: String,
    email: String,
    totens: Array,
    selectedTotem: Object
  }

  constructor(data = {}) {
    this.setData(data)
  }

  setData (data) {
    this._data.id  = data.id || ''
    this._data.email  = data.email || ''
    this._data.totens = data.totens || ''
  }

  getData () {
    return this._data
  }

 
}

export default AdminModel;